import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  return (
    <section id="voice" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <div className="max-w-2xl">
        <span className="text-xs font-medium tracking-widest text-secondary-700">VOICES</span>
        <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">瓜友怎么说</h2>
        <p className="mt-2 text-sm text-foreground-600">
          没有刻意挑选，只是把近期回帖里一些真实的感受放上来。社区的样子，由说话的人决定。
        </p>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <i className="ri-double-quotes-l text-2xl text-secondary-400" />
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
              {item.content}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-sm font-medium text-background-50">
                {item.avatar}
              </span>
              <span className="flex-1">
                <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                <span className="block text-xs text-foreground-500">{item.tag}</span>
              </span>
              <span className="flex items-center gap-1 text-xs text-accent-600">
                <i className="ri-heart-3-fill" />
                {item.likes}
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}